import { render, staticRenderFns } from "./ViewSale.vue?vue&type=template&id=c7161a78&scoped=true&"
import script from "./ViewSale.vue?vue&type=script&lang=js&"
export * from "./ViewSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7161a78",
  null
  
)

export default component.exports